import { BaseModel } from './../../../data/models'
export class TestLine extends BaseModel {

  public name: string

  constructor() { super() }
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/data/models/test-line/test-line.ts